/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Handling of template degradation */
export enum DegradationHandling {
  RequireRefresh,
  GradualDegradation,
  ImmediateExpiry,
  AdaptiveThreshold,
}

export type DegradationHandlingArgs = DegradationHandling;

export function getDegradationHandlingEncoder(): FixedSizeEncoder<DegradationHandlingArgs> {
  return getEnumEncoder(DegradationHandling);
}

export function getDegradationHandlingDecoder(): FixedSizeDecoder<DegradationHandling> {
  return getEnumDecoder(DegradationHandling);
}

export function getDegradationHandlingCodec(): FixedSizeCodec<
  DegradationHandlingArgs,
  DegradationHandling
> {
  return combineCodec(
    getDegradationHandlingEncoder(),
    getDegradationHandlingDecoder(),
  );
}
